import { Step } from '../components/steps/Step';
import { NotSure, OnboardingFlows, Other } from './common';

export const contentTypePersonal: Step = {
    id: OnboardingFlows.UseCases,
    title: 'How do you plan to use D-ID?',
    multiSelect: false,
    randomize: true,
    options: [
        {
            label: 'Sales',
        },
        {
            label: 'Marketing',
        },
        {
            label: 'Training / Education',
        },
        {
            label: 'Just for fun',
        },
        {
            label: 'Creator content',
        },
        {
            label: NotSure,
        },
        {
            id: 'onboard_new_usecases_other',
            label: Other,
        },
    ],
};
